import {
  HeaderListItem,
  ListItem,
  ListValue,
  StatefulList,
  ValueListItem,
} from './stateful-list.types';

/**
 * Type guard for `ValueListItem`.
 *
 * @param item - A list item.
 * @returns `true` if the item is a `ValueListItem`.
 */
export function isValueItem(item: ListItem): item is ValueListItem {
  return 'value' in item;
}

/**
 * Type guard for `HeaderListItem`.
 *
 * @param item - A list item.
 * @returns `true` if the item is a `HeaderListItem`.
 */
export function isHeaderItem(item: ListItem): item is HeaderListItem {
  return 'isHeader' in item && item.isHeader;
}

/**
 * Finds and returns the list items that correspond to the provided values.
 * This is useful for retrieving the full item details for a set of selected values.
 *
 * @param list - The StatefulList to search within
 * @param values - An array of ListValue to find in the list
 * @returns An array of ValueListItem that match the provided values
 */
export function findItemsByValues(list: StatefulList, values: ListValue[]) {
  const foundItems: ValueListItem[] = [];
  for (const value of values) {
    const item = list.valueItemMap.get(value);
    if (item) {
      foundItems.push(item);
    }
  }

  return foundItems;
}
